<template>
        <div class="wrapper">
        <v-layout>
            <v-main style="font-size:14px;">
                <v-container>
                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                                        <h4 class="
                                        text-h6
                                        text-md-h6
                                        text-lg-h5
                                        text-xl-h5
                                        text-truncate">
                                            Data Privacy
                                        </h4>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <b>1. General Information</b><br />
                            We take the protection of your personal data very seriously.
                            This data privacy statement explains how we collect, process, and use your data when you use our website and web application.
                            All data processing activities are carried out in compliance with the General Data Protection Regulation (GDPR) and other applicable laws.<br/><br />

                            <b>2. Data protection officer</b><br />
                            The legal bases for the data protection are the General Data Protection Regulation (GDPR),
                            the Federal Data Protection Act (BDSG), the Lower Saxony Data Protection Act (NdsDSG) and
                            the Telemedia Act (TMG). The UMG declares that it complies with the applicable laws, in
                            particular when processing personal data.<br/><br />
                            The UMG Data Protection Officer can be contacted at:<br />
                            Universitätsmedizin Göttingen<br/>
                            - Datenschutzbeauftragter -<br/>
                            37099 Göttingen<br />
                            Germany<br/>
                            Email:
                            <a href="#" class="cryptedmail" data-name="datenschutz"
                                                data-domain="med.uni-goettingen.de" data-tld="de"
                                                onclick="window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld; return false;">
                                            </a>
                            <br />
                            Phone: +49 (0)551 3922762<br /><br/>

                            <b>3. Data We Collect</b><br />
                            When you use our web application, the following types of data may be collected:<br/>

                            <ul>
                                <li>Uploaded data: Data files you upload within the application.</li>
                                <li>Technically required data.</li>
                                <li>Cookies: Small files stored on your device to enhance the functionality and usability
                                of the website. See section 9 for more information on cookies.</li>
                            </ul>

                            <b>4. Purpose of Data Processing</b><br />
                            We collect and process your data for the following purposes:

                                To provide and operate the web application.
                                To enable data uploads and ensure secure storage.
                                To respond to user inquiries and provide customer support.
                                To analyze usage trends and improve the website’s functionality.
                                To comply with legal obligations, including data retention requirements.
                                <br /><br/>

                            <b>5. Legal Basis for Processing</b><br />
                            The legal basis for processing your data depends on the purpose:<br/>

                            <ul>
                                <li>Consent (Article 6(1)(a) GDPR): For processing activities where you explicitly grant permission.</li>
                                <li>Performance of a Contract (Article 6(1)(b) GDPR): For providing the requested services.</li>
                                <li>Legitimate Interests (Article 6(1)(f) GDPR): For analytics and improving our services.</li>
                                <li>Legal Obligation (Article 6(1)(c) GDPR): To comply with applicable laws and regulations.</li>
                            </ul>

                            <b>6. Technically required data</b><br />
                            When you visit our website, we collect the following data, which is technically necessary for
                            us to ensure the functionality of the website, as well as the stability and security of our
                            information technology systems and to enable optimization of the website:<br/><br/>
                            <ul>
                                <li>IP address</li>
                                <li>Date and time of access to this website</li>
                                <li>Time zone difference to Greenwich Mean Time(GMT)</li>
                                <li>Access status/HTTP status code</li>
                                <li>Amount of data transferred in each case</li>
                                <li>Browser type</li>
                                <li>Operating system</li>
                                <li>Language and version of the browser software</li>
                            </ul>

                            <b>7. Recipients of personal data</b><br />
                                Onkopus, including the web server, the web front end and all Onkopus modules, are hosted on our own servers.
                                All data collected is processed locally on our servers within the
                                Department of Medical Bioinformatics, UMG. <br />

                                Uploaded files are processed securely and are accessible only to authorized personnel.
                                We will not access or use your uploaded data for purposes other than providing the service unless required by law.
                                Please ensure that you do not upload sensitive data.
                                <br /><br/>

                            <b>8. Data Sharing</b><br />
                            We will not share your personal data with third parties.

                                <br /><br/>

                            <b>9. Cookies and Analytics</b><br />
                            We use the web analysis tool Matomo to enhance the functionality and usability of our website.
                            You can configure your browser to reject cookies or notify you when cookies are being set.

                            We may also use analytics tools to understand user behavior and improve the website.
                            These tools anonymize data where possible.
                            <br /><br/>

                            <b>10. Your Rights</b><br />
                            You have the following rights regarding the processing of your personal data:<br />
                            <ul>
                                <li>Right to access (Article 15 GDPR).</li>
                                <li>Right to rectification (Article 16 GDPR).</li>
                                <li>Right to erasure ("right to be forgotten") (Article 17 GDPR).</li>
                                <li>Right to restriction of processing (Article 18 GDPR).</li>
                                <li>Right to data portability (Article 20 GDPR).</li>
                                <li>Right to object to processing (Article 21 GDPR).</li>
                                <li>Right to withdraw consent (Article 7(3) GDPR).</li>
                            </ul>

                            To exercise these rights, please contact the UMG data protection officer.
                            You also have the right to lodge a complaint with a supervisory authority.

                            <br /><br/>

                            <b>11. Data Retentions and Data Security</b><br />
                            Uploaded data will be stored for the duration of your use of the application unless otherwise specified.
                            Uploaded files are automatically deleted after 72 hours.

                            We implement technical and organizational measures to ensure the security of your data and
                            protect it against unauthorized access, alteration, disclosure, or destruction.

                            <br /><br/>

                            <b>12. Changes to This Privacy Policy</b><br />
                            We may update this privacy policy from time to time. The latest version will always be available on our website.
                            <br /><br/>
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-layout>
    </div>
</template>
<style scoped>

ul {
    font-size:12px;
}

ul li {

}
</style>
